import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoPostoManutencao({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'postoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoPostoManutencao({ payload }) {
  try {
    const { poco_codigo, params } = payload;

    yield call(api.delete, `postoscomboios/${poco_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { poco_codigo, params } = payload;

    yield call(api.post, 'postoscomboios', poco_codigo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/postomanutencao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { poco_codigo } = payload;

    const { data } = yield call(api.get, `postoscomboios/${poco_codigo}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaopostomanutencao, params } = payload;

    yield call(api.put, 'postoscomboios', operacaopostomanutencao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/postomanutencao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'postoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaopostomanutencao/POSTOMANUTENCAO_IN_REQUEST',
    requestOperacaoPostoManutencao
  ),
  takeLatest(
    '@operacaopostomanutencao/DELETE_POSTOMANUTENCAO',
    deleteOperacaoPostoManutencao
  ),
  takeLatest(
    '@operacaopostomanutencao/SUCCESS_REMOVE',
    requestOperacaoPostoManutencao
  ),
  takeLatest('@operacaopostomanutencao/STORE_POSTOMANUTENCAO', store),
  takeLatest('@operacaopostomanutencao/FIND_POSTOMANUTENCAO', find),
  takeLatest('@operacaopostomanutencao/UPDATE_POSTOMANUTENCAO', update),
  takeLatest('@operacaopostomanutencao/RECORD_FILTERING', applyedFilters),
]);
